export const luhnCheck = (cardNumber: string): boolean => {
  // Remove espaços em branco e caracteres não numéricos
  const cleanedNumber = cardNumber.replace(/\D/g, '');
  if (cleanedNumber.length === 0) return false;

  let sum = 0;
  let shouldDouble = false;

  for (let i = cleanedNumber.length - 1; i >= 0; i--) {
    let digit = parseInt(cleanedNumber[i], 10);
    if (shouldDouble) {
      digit *= 2;
      if (digit > 9) digit -= 9;
    }

    sum += digit;
    shouldDouble = !shouldDouble;
  }

  return sum % 10 === 0;
};
